
import React from "react";
import { Movie } from "@/types/movie";
import { Span } from "@/components/ui/typography";
import { getPosterUrl } from "@/utils/imageUtils";
import { useIsMobile } from "@/hooks/use-mobile";

interface DialogPosterProps {
  movie: Movie;
  variant?: "dialog" | "page";
}

const DialogPoster: React.FC<DialogPosterProps> = ({ movie, variant = "dialog" }) => {
  const isMobile = useIsMobile();
  const { title } = movie;
  
  // Get the poster URL from posterPath (pure camelCase)
  const posterUrl = getPosterUrl(movie);
  
  // Determine rounding classes based on variant and screen size
  const getRoundingClasses = () => {
    if (variant === "page") {
      // For page variant, apply conditional rounding
      return isMobile ? "rounded-t-lg" : "md:rounded-l-lg";
    }
    return ""; // No rounding for dialog variant
  };
  
  return (
    <div className={`
      p-0
      ${isMobile 
        ? "w-full flex-shrink-0" 
        : "md:w-1/2"
      }
    `}>
      <div className={`
        w-full 
        ${isMobile 
          ? "aspect-[3/2] min-h-[250px]" 
          : "aspect-[2/3] min-h-[400px]"
        }
      `}>
        {posterUrl ? (
          <img
            src={posterUrl}
            alt={`${title} poster`}
            className={`
              w-full h-full object-contain bg-mono-slateGray
              ${getRoundingClasses()}
            `}
          />
        ) : (
          <div className={`
            w-full h-full flex items-center justify-center bg-mono-slateGray
            ${getRoundingClasses()}
          `}>
            <Span size="h2" weight="bold" className="text-mono-seasalt text-center px-4">{title}</Span>
          </div>
        )}
      </div>
    </div>
  );
};

export default DialogPoster;
